import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  preview: {
    id: 'studio.TJo5E6',
    defaultMessage: 'Preview',
  },
});
